import React, {Component} from 'react';
import { Container, Row, Col } from 'reactstrap';
import { sendData } from '../../analytics/sendData';
import { FormattedMessage } from 'react-intl';

class Impressum extends Component {

	componentDidMount() {
        sendData('', '', '', 'viewed', { page: 'impressum' });
		window.scrollTo(0, 0);
	}

	render() {

		return (
            <section className="terms privacy-policy">
			<Container fluid>
				<Row>
					<Col xs="12">
						<div className="terms-title-wrap">
							<h2 className="terms-section-title">
                                Impressum
                            </h2>
						</div>
					</Col>
				</Row>
				<Row className="no-gutters">
					<Col xs="12" className="terms-list">
                        <p className="terms-para">
                            Silver Lines
                        </p>
                        <p className="terms-para">
                            Van Diemenstraat 356
                        </p>
                        <p className="terms-para">
                            1013CR Amsterdam
                        </p>
                        <p className="terms-para">
                            Niederlande
                        </p>
                        <p className="terms-para">
                            Phone: 044 5816 275
                        </p>
                        <p className="terms-para">
                            E-mail: <a href="mailto:gamelords@silverlines.info">gamelords@silverlines.info</a>
                        </p>
                    </Col>
				</Row>
			</Container>
		</section>
		);

	}

}

export default Impressum;



// WEBPACK FOOTER //
// ./src/components/StaticPages/Impressum.js